import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import api from "@/lib/api";
import { Trophy, TrendingUp } from "lucide-react";

export default function RankingPage() {
  const { t } = useTranslation();
  const today = new Date();
  const y = today.getFullYear();
  const m = today.getMonth();
  const pad = (n) => String(n).padStart(2, "0");
  // Costruiamo la stringa data localmente per evitare shift di timezone (Italy UTC+1/2)
  const firstDay = `${y}-${pad(m + 1)}-01`;
  const lastDayNum = new Date(y, m + 1, 0).getDate();
  const lastDay = `${y}-${pad(m + 1)}-${pad(lastDayNum)}`;
  const [from, setFrom] = useState(firstDay);
  const [to, setTo] = useState(lastDay);
  const [data, setData] = useState(null);

  const load = async () => {
    const { data } = await api.get("/dashboard/ranking", { params: { date_from: from, date_to: to } });
    setData(data);
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [from, to]);

  const max = data && data.ranking.length ? Math.max(...data.ranking.map((r) => r.total), 1) : 1;

  return (
    <div className="space-y-6">
      <div>
        <div className="text-xs font-bold uppercase tracking-[0.15em] text-slate-500">{t("auto.analytics_kicker")}</div>
        <h1 className="mt-1 text-3xl font-bold text-slate-900 lg:text-4xl">{t("menu.ranking")}</h1>
        <p className="mt-1 text-sm text-slate-500">{t("auto.confronto_produzione_per_periodo_utile_per_assegnare_commess")}</p>
      </div>

      <div className="flex flex-wrap items-end gap-3 rounded-sm border border-slate-200 bg-white p-4">
        <div><label className="text-xs text-slate-500">{t("auto.dal")}</label><input type="date" value={from} onChange={(e) => setFrom(e.target.value)} className="ml-2 rounded-sm border border-slate-300 px-2 py-1 font-mono text-sm" data-testid="rank-from" /></div>
        <div><label className="text-xs text-slate-500">{t("auto.al")}</label><input type="date" value={to} onChange={(e) => setTo(e.target.value)} className="ml-2 rounded-sm border border-slate-300 px-2 py-1 font-mono text-sm" data-testid="rank-to" /></div>
      </div>

      <div className="rounded-sm border border-slate-200 bg-white p-5">
        <div className="mb-4 flex items-center gap-2">
          <Trophy className="h-5 w-5 text-orange-500" />
          <div className="text-xs font-bold uppercase tracking-widest text-slate-500">{t("auto.classifica_kicker")}</div>
        </div>
        {!data && <div className="text-slate-400">{t("auto.caricamento")}</div>}
        {data && data.ranking.length === 0 && <div className="py-6 text-center text-slate-400">{t("auto.nessun_tecnico")}</div>}
        {data && data.ranking.length > 0 && (
          <ol className="space-y-3">
            {data.ranking.map((r, idx) => (
              <li key={r.technician_id} className="rounded-sm border border-slate-100 bg-slate-50 p-4" data-testid={`rank-${idx}`}>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className={`grid h-8 w-8 place-items-center rounded-sm font-mono text-sm font-bold ${idx === 0 ? "bg-orange-500 text-white" : idx === 1 ? "bg-slate-400 text-white" : idx === 2 ? "bg-amber-700 text-white" : "bg-slate-200 text-slate-700"}`}>
                      {idx + 1}
                    </div>
                    <div>
                      <div className="font-semibold text-slate-900">{r.technician_name}</div>
                      <div className="text-xs text-slate-500">{r.count} {t("auto.lavorazioni_count")}</div>
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="font-mono text-xl font-semibold text-slate-900">€ {Number(r.total).toFixed(2)}</div>
                    <div className="flex items-center justify-end gap-1 text-xs text-emerald-600">
                      <TrendingUp className="h-3 w-3" /> {t("auto.produzione_lorda_label")}
                    </div>
                  </div>
                </div>
                <div className="mt-3 h-2 overflow-hidden rounded-sm bg-slate-200">
                  <div
                    className="h-full bg-[#0052FF] transition-all duration-500"
                    style={{ width: `${(r.total / max) * 100}%` }}
                  />
                </div>
              </li>
            ))}
          </ol>
        )}
      </div>
    </div>
  );
}
